import { render, staticRenderFns } from "./DetalleSolicitud.vue?vue&type=template&id=2ad9bf38&scoped=true"
import script from "./DetalleSolicitud.vue?vue&type=script&lang=js"
export * from "./DetalleSolicitud.vue?vue&type=script&lang=js"
import style0 from "./DetalleSolicitud.vue?vue&type=style&index=0&id=2ad9bf38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad9bf38",
  null
  
)

export default component.exports